import React from "react";
import { object, bool } from "prop-types";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { Link } from "@quintype/components";
import "../author.m.css";

export const AuthorInfo = ({ author, ismobile }) => {
  const size = Object.entries(author.social).length;

  const icon = { width: "44px", height: "44px", viewBox: "0 0 44 44" };
  return (
    <div className="author-box" styleName="author-box">
      <div styleName="author-card">
        <div styleName="author-info">
          {author["avatar-url"] ? (
            <img src={author["avatar-url"]} alt={author.name} styleName="author-image" />
          ) : (
            <SvgIconHandler iconStyle={"author-image"} type="profile" styleName="author-image" />
          )}
          <div>
            <h2 styleName="author-name">{author.name}</h2>
            <p styleName="author-role">{author.metadata.designation}</p>
          </div>
        </div>
        {author.social && Object.keys(author.social).length > 0 && (
          <div styleName="author-socials">
            {Object.entries(author.social).map(([item, value], index) => {
              if (value && value.url) {
                return (
                  <Link key={index} href={value.url} target="_blank">
                    <SvgIconHandler
                      type={item === "twitter" ? `x` : `${item}`}
                      iconStyle={{ color: "#596E79" }}
                      height={icon.height}
                      width={icon.width}
                      viewBox={icon.viewBox}
                    />
                  </Link>
                );
              }
              return null;
            })}
          </div>
        )}
      </div>
      {author.bio && <p styleName="author-bio">{author.bio}</p>}
    </div>
  );
};

AuthorInfo.propTypes = {
  author: object,
  ismobile: bool,
};
